unit unit_KontaktTermine;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.WebCtrls, dateutils;

type
  TKontaktTermine = class(TForm)
    xdsTermine: TXDataWebDataSet;
    btnzurueck: TButton;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    xdsTermineArtikelnummer: TXDataWebEntityField;
    xdsTermineUID: TStringField;
    xdsTermineBeginn: TDateTimeField;
    xdsTermineEnde: TDateTimeField;
    xdsTermineBetreff: TStringField;
    xdsTermineTerminNotiz: TStringField;
    xdsTermineQuelle: TStringField;
    xdsTermineGUIDOutlook: TStringField;
    xdsTermineShape: TIntegerField;
    xdsTermineColor: TIntegerField;
    xdsTermineAlarm: TBooleanField;
    xdsTermineResource: TIntegerField;
    xdsTermineLastModificationTime: TDateTimeField;
    xdsTermineGeburtstag: TBooleanField;
    xdsTermineAlarmBefore: TIntegerField;
    xdsTerminePersonalnummer: TIntegerField;
    xdsTermineKundennummer: TStringField;
    xdsTermineAllDayEventOutlook: TBooleanField;
    xdsTermineTMSCaption: TBooleanField;
    xdsTermineRECURRENCY: TStringField;
    xdsTermineMINTIME: TDateTimeField;
    xdsTermineMAXTIME: TDateTimeField;
    xdsTermineNachname: TStringField;
    xdsTermineObjektReferenz: TStringField;
    xdsTermineObjektnummer: TStringField;
    xdsTermineTerminArt: TIntegerField;
    xdsTermineBeginnDatum: TDateTimeField;
    xdsTermineBeginnUhrzeit: TDateTimeField;
    xdsTermineEndeDatum: TDateTimeField;
    xdsTermineEndeUhrzeit: TDateTimeField;
    xdsTermineKalenderAnzeige: TBooleanField;
    xdsTermineStundensatz: TFloatField;
    xdsTermineDauerStunden: TFloatField;
    xdsTerminegefahrenekm: TFloatField;
    xdsTermineAufwand: TFloatField;
    xdsTermineabgerechnet: TBooleanField;
    xdsTermineverteilt: TDateTimeField;
    xdsTermineTerminErledigt: TDateTimeField;
    xdsTermineAnsprechpartner: TStringField;
    xdsTermineLocation: TStringField;
    xdsTermineGoogleID: TStringField;
    xdsTermineGoogleCreatedUTC: TDateTimeField;
    xdsTermineGoogleUpdatedUTC: TDateTimeField;
    xdsTermineGoogleStatus: TStringField;
    xdsTermineVorname: TStringField;
    xdsTerminePNachname: TStringField;
    xdsTerminePVorname: TStringField;
    xdsTermineArtikelueberschrift: TStringField;
    xdsTerminePFarbe: TIntegerField;
    xdsTermineKontaktart: TStringField;
    xdsTermineAuftrag: TStringField;
    xdsTermineRechnung: TStringField;
    xdsTermineRechnungPosID: TStringField;
    xdsTermineAbrechnen: TBooleanField;
    btnTerminNeu: TButton;
    procedure btnzurueckClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure xdsTermineAfterOpen(DataSet: TDataSet);
    procedure btnTerminNeuClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    MerkerKundennummer:string;
    MerkerNachname:string;
    MerkerVorname:string;
    EinzelCard:THTMLDiv;
    procedure EinzelCardclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  KontaktTermine: TKontaktTermine;

implementation
  uses unit1, unit2, unit_Einzeltermin;
{$R *.dfm}

procedure TKontaktTermine.btnTerminNeuClick(Sender: TObject);
    var
  LFrm:TfrmEinzeltermin;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmEinzeltermin;
    begin
      LForm:=(AForm as TfrmEinzeltermin);
      lform.TerminUID:='';
      decodedatetime(date+time,ajahr,amonat,atag,astunde,aminute,asekunde,ams);
      lform.NeuStartDateTime:=encodedatetime(ajahr, amonat,atag,astunde,0,0,0);
      lform.NeuEndDateTime:=encodedatetime(ajahr, amonat,atag,astunde+1,0,0,0);
      lform.NeuKundennummer:=MerkerKundennummer;
      container2.html.text:='';
      xdsTermine.close;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsTermine.load;
    end;

  begin
  LFrm:=TfrmEinzeltermin.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);
end;

procedure TKontaktTermine.btnzurueckClick(Sender: TObject);
begin
  xdsTermine.close;
  self.Close;
end;

procedure TKontaktTermine.EinzelCardclick(Sender:TObject);
  var
  LFrm:TfrmEinzeltermin;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmEinzeltermin;
    begin
      LForm:=(AForm as TfrmEinzeltermin);
      lform.TerminUID:=(sender as THTMLDiv).ElementID;;
      container2.HTML.Text:='';
      xdsTermine.close;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsTermine.load;
    end;

  begin
  LFrm:=TfrmEinzeltermin.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TKontaktTermine.WebFormShow(Sender: TObject);
begin
  xdsTermine.close;
  xdstermine.querystring:='$filter=Kundennummer eq '+QuotedStr(MerkerKundennummer)+'&$orderby=Beginn DESC';
  XdsTermine.load;
end;

procedure TKontaktTermine.xdsTermineAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Termine für '+MerkerKundennummer+' | '+trim(MerkerVorname+' '+ MerkerNachname)+'</h5></nav>';
  myelement:=Container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnTerminNeu.ParentElement:=myelement;
  Container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;
  xdsTermine.first;
  while not xdstermine.eof do
  begin
    if xdsTermineTerminArt.asinteger=0 then Einzelkarte:='<div class="card-header bg-info">';
    if xdsTermineTerminArt.asinteger=1 then Einzelkarte:='<div class="card-header bg-success">';
    if xdsTermineTerminArt.asinteger=3 then Einzelkarte:='<div class="card-header bg-primary">';
    If trunc(XDSTermineBeginn.AsDateTime)=trunc(XDSTermineEnde.AsDateTime) then
    begin
      Einzelkarte:=Einzelkarte+'<h5>'+formatdatetime('DDD DD.MM.YYYY hh:mm',XDSTermineBeginn.Asdatetime)+' - '+formatdatetime('hh:mm',XDSTermineEndeUhrzeit.Asdatetime)+'</h5>';
    end
    else
    begin
      Einzelkarte:=Einzelkarte+'<h5>'+formatdatetime('DDD DD.MM.YYYY hh:mm',XDSTermineBeginn.Asdatetime)+' - '+formatdatetime('DDD DD.MM.YYYY hh:mm',XDSTermineEnde.Asdatetime)+'</h5>';
    end;
    Einzelkarte:=Einzelkarte+'<b>'+xdsTermineBetreff.AsString+'</b></div>';
    Einzelkarte:=Einzelkarte+'<div class="card-body "><h6>'+xdsTermineTerminNotiz.AsString+'</h6>';
    Einzelkarte:=Einzelkarte+'<br><i>Termin erledigt am: </i><b>'+xdsTermineTerminErledigt.AsString+'</b>';
    if xdsTermineLocation.asstring<>'' then Einzelkarte:=Einzelkarte+'<br><i>Ort: </i><b>'+xdsTerminelocation.AsString+'</b>';
    if xdsTerminePersonalnummer.asstring<>'' then
    begin
      Einzelkarte:=Einzelkarte+'<br><i>Mitarbeiter: </i><b>'+xdsTerminePersonalnummer.AsString+' '+trim(xdsterminePVorname.asstring+' '+xdsterminePNachname.asstring)+'</b>';
    end;
    if xdsTermineAuftrag.asstring<>'' then
    begin
      Einzelkarte:=Einzelkarte+'<br><i>Auftrag: </i><b>'+xdsTermineAuftrag.AsString+'</b>';
    end;
    if xdsTermineKontaktart.asstring<>'' then
    begin
      Einzelkarte:=Einzelkarte+'<br><i>Kontaktart: </i><b>'+xdsTermineKontaktart.AsString+'</b>';
    end;
    Einzelkarte:=Einzelkarte+'</div>';
    if xdsTermineTerminArt.asinteger=0 then Einzelkarte:=Einzelkarte+'<div class="card-footer"><i>Termin</i></div>';
    if xdsTermineTerminArt.asinteger=1 then Einzelkarte:=Einzelkarte+'<div class="card-footer"><i>Wiedervorlage</i></div>';
    if xdsTermineTerminArt.asinteger=3 then Einzelkarte:=Einzelkarte+'<div class="card-footer"><i>Aktivität</i></div>';
    myelement:=Container2.ElementHandle;
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:=xdsTermineUID.asstring;
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.WidthStyle:=ssPercent;
    EinzelCard.WidthPercent:=100;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card m-1 border-info';
    EinzelCard.OnClick:=@EinzelCardClick;
    EinzelCard.ParentElement:=myelement;
    xdstermine.next;
  end;
end;

procedure TKontaktTermine.LoadDFMValues;
begin
  inherited LoadDFMValues;

  btnzurueck := TButton.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnTerminNeu := TButton.Create(Self);
  xdsTermine := TXDataWebDataSet.Create(Self);
  xdsTermineArtikelnummer := TXDataWebEntityField.Create(Self);
  xdsTermineUID := TStringField.Create(Self);
  xdsTermineBeginn := TDateTimeField.Create(Self);
  xdsTermineEnde := TDateTimeField.Create(Self);
  xdsTermineBetreff := TStringField.Create(Self);
  xdsTermineTerminNotiz := TStringField.Create(Self);
  xdsTermineQuelle := TStringField.Create(Self);
  xdsTermineGUIDOutlook := TStringField.Create(Self);
  xdsTermineShape := TIntegerField.Create(Self);
  xdsTermineColor := TIntegerField.Create(Self);
  xdsTermineAlarm := TBooleanField.Create(Self);
  xdsTermineResource := TIntegerField.Create(Self);
  xdsTermineLastModificationTime := TDateTimeField.Create(Self);
  xdsTermineGeburtstag := TBooleanField.Create(Self);
  xdsTermineAlarmBefore := TIntegerField.Create(Self);
  xdsTerminePersonalnummer := TIntegerField.Create(Self);
  xdsTermineKundennummer := TStringField.Create(Self);
  xdsTermineAllDayEventOutlook := TBooleanField.Create(Self);
  xdsTermineTMSCaption := TBooleanField.Create(Self);
  xdsTermineRECURRENCY := TStringField.Create(Self);
  xdsTermineMINTIME := TDateTimeField.Create(Self);
  xdsTermineMAXTIME := TDateTimeField.Create(Self);
  xdsTermineNachname := TStringField.Create(Self);
  xdsTermineObjektReferenz := TStringField.Create(Self);
  xdsTermineObjektnummer := TStringField.Create(Self);
  xdsTermineTerminArt := TIntegerField.Create(Self);
  xdsTermineBeginnDatum := TDateTimeField.Create(Self);
  xdsTermineBeginnUhrzeit := TDateTimeField.Create(Self);
  xdsTermineEndeDatum := TDateTimeField.Create(Self);
  xdsTermineEndeUhrzeit := TDateTimeField.Create(Self);
  xdsTermineKalenderAnzeige := TBooleanField.Create(Self);
  xdsTermineStundensatz := TFloatField.Create(Self);
  xdsTermineDauerStunden := TFloatField.Create(Self);
  xdsTerminegefahrenekm := TFloatField.Create(Self);
  xdsTermineAufwand := TFloatField.Create(Self);
  xdsTermineabgerechnet := TBooleanField.Create(Self);
  xdsTermineverteilt := TDateTimeField.Create(Self);
  xdsTermineTerminErledigt := TDateTimeField.Create(Self);
  xdsTermineAnsprechpartner := TStringField.Create(Self);
  xdsTermineLocation := TStringField.Create(Self);
  xdsTermineGoogleID := TStringField.Create(Self);
  xdsTermineGoogleCreatedUTC := TDateTimeField.Create(Self);
  xdsTermineGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsTermineGoogleStatus := TStringField.Create(Self);
  xdsTermineVorname := TStringField.Create(Self);
  xdsTerminePNachname := TStringField.Create(Self);
  xdsTerminePVorname := TStringField.Create(Self);
  xdsTermineArtikelueberschrift := TStringField.Create(Self);
  xdsTerminePFarbe := TIntegerField.Create(Self);
  xdsTermineKontaktart := TStringField.Create(Self);
  xdsTermineAuftrag := TStringField.Create(Self);
  xdsTermineRechnung := TStringField.Create(Self);
  xdsTermineRechnungPosID := TStringField.Create(Self);
  xdsTermineAbrechnen := TBooleanField.Create(Self);

  btnzurueck.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnTerminNeu.BeforeLoadDFMValues;
  xdsTermine.BeforeLoadDFMValues;
  xdsTermineArtikelnummer.BeforeLoadDFMValues;
  xdsTermineUID.BeforeLoadDFMValues;
  xdsTermineBeginn.BeforeLoadDFMValues;
  xdsTermineEnde.BeforeLoadDFMValues;
  xdsTermineBetreff.BeforeLoadDFMValues;
  xdsTermineTerminNotiz.BeforeLoadDFMValues;
  xdsTermineQuelle.BeforeLoadDFMValues;
  xdsTermineGUIDOutlook.BeforeLoadDFMValues;
  xdsTermineShape.BeforeLoadDFMValues;
  xdsTermineColor.BeforeLoadDFMValues;
  xdsTermineAlarm.BeforeLoadDFMValues;
  xdsTermineResource.BeforeLoadDFMValues;
  xdsTermineLastModificationTime.BeforeLoadDFMValues;
  xdsTermineGeburtstag.BeforeLoadDFMValues;
  xdsTermineAlarmBefore.BeforeLoadDFMValues;
  xdsTerminePersonalnummer.BeforeLoadDFMValues;
  xdsTermineKundennummer.BeforeLoadDFMValues;
  xdsTermineAllDayEventOutlook.BeforeLoadDFMValues;
  xdsTermineTMSCaption.BeforeLoadDFMValues;
  xdsTermineRECURRENCY.BeforeLoadDFMValues;
  xdsTermineMINTIME.BeforeLoadDFMValues;
  xdsTermineMAXTIME.BeforeLoadDFMValues;
  xdsTermineNachname.BeforeLoadDFMValues;
  xdsTermineObjektReferenz.BeforeLoadDFMValues;
  xdsTermineObjektnummer.BeforeLoadDFMValues;
  xdsTermineTerminArt.BeforeLoadDFMValues;
  xdsTermineBeginnDatum.BeforeLoadDFMValues;
  xdsTermineBeginnUhrzeit.BeforeLoadDFMValues;
  xdsTermineEndeDatum.BeforeLoadDFMValues;
  xdsTermineEndeUhrzeit.BeforeLoadDFMValues;
  xdsTermineKalenderAnzeige.BeforeLoadDFMValues;
  xdsTermineStundensatz.BeforeLoadDFMValues;
  xdsTermineDauerStunden.BeforeLoadDFMValues;
  xdsTerminegefahrenekm.BeforeLoadDFMValues;
  xdsTermineAufwand.BeforeLoadDFMValues;
  xdsTermineabgerechnet.BeforeLoadDFMValues;
  xdsTermineverteilt.BeforeLoadDFMValues;
  xdsTermineTerminErledigt.BeforeLoadDFMValues;
  xdsTermineAnsprechpartner.BeforeLoadDFMValues;
  xdsTermineLocation.BeforeLoadDFMValues;
  xdsTermineGoogleID.BeforeLoadDFMValues;
  xdsTermineGoogleCreatedUTC.BeforeLoadDFMValues;
  xdsTermineGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsTermineGoogleStatus.BeforeLoadDFMValues;
  xdsTermineVorname.BeforeLoadDFMValues;
  xdsTerminePNachname.BeforeLoadDFMValues;
  xdsTerminePVorname.BeforeLoadDFMValues;
  xdsTermineArtikelueberschrift.BeforeLoadDFMValues;
  xdsTerminePFarbe.BeforeLoadDFMValues;
  xdsTermineKontaktart.BeforeLoadDFMValues;
  xdsTermineAuftrag.BeforeLoadDFMValues;
  xdsTermineRechnung.BeforeLoadDFMValues;
  xdsTermineRechnungPosID.BeforeLoadDFMValues;
  xdsTermineAbrechnen.BeforeLoadDFMValues;
  try
    Name := 'KontaktTermine';
    Width := 640;
    Height := 480;
    Caption := 'KontaktTermine';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 112;
    btnzurueck.Top := 334;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 4;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 1;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnTerminNeu.SetParentComponent(Self);
    btnTerminNeu.Name := 'btnTerminNeu';
    btnTerminNeu.Left := 224;
    btnTerminNeu.Top := 334;
    btnTerminNeu.Width := 96;
    btnTerminNeu.Height := 25;
    btnTerminNeu.Caption := '+ Neuer Termin';
    btnTerminNeu.ChildOrder := 4;
    btnTerminNeu.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnTerminNeu.ElementFont := efCSS;
    btnTerminNeu.ElementPosition := epIgnore;
    btnTerminNeu.HeightStyle := ssAuto;
    btnTerminNeu.HeightPercent := 100.000000000000000000;
    btnTerminNeu.WidthStyle := ssAuto;
    btnTerminNeu.WidthPercent := 100.000000000000000000;
    SetEvent(btnTerminNeu, Self, 'OnClick', 'btnTerminNeuClick');
    xdsTermine.SetParentComponent(Self);
    xdsTermine.Name := 'xdsTermine';
    xdsTermine.AfterOpen := xdsTermineAfterOpen;
    xdsTermine.EntitySetName := 'TermineNeu';
    xdsTermine.Connection := DM2.XDataWebConnection1;
    xdsTermine.Left := 312;
    xdsTermine.Top := 40;
    xdsTermineArtikelnummer.SetParentComponent(xdsTermine);
    xdsTermineArtikelnummer.Name := 'xdsTermineArtikelnummer';
    xdsTermineArtikelnummer.FieldName := 'Artikelnummer';
    xdsTermineUID.SetParentComponent(xdsTermine);
    xdsTermineUID.Name := 'xdsTermineUID';
    xdsTermineUID.FieldName := 'UID';
    xdsTermineUID.Required := True;
    xdsTermineUID.Size := 38;
    xdsTermineBeginn.SetParentComponent(xdsTermine);
    xdsTermineBeginn.Name := 'xdsTermineBeginn';
    xdsTermineBeginn.FieldName := 'Beginn';
    xdsTermineEnde.SetParentComponent(xdsTermine);
    xdsTermineEnde.Name := 'xdsTermineEnde';
    xdsTermineEnde.FieldName := 'Ende';
    xdsTermineBetreff.SetParentComponent(xdsTermine);
    xdsTermineBetreff.Name := 'xdsTermineBetreff';
    xdsTermineBetreff.FieldName := 'Betreff';
    xdsTermineBetreff.Size := 255;
    xdsTermineTerminNotiz.SetParentComponent(xdsTermine);
    xdsTermineTerminNotiz.Name := 'xdsTermineTerminNotiz';
    xdsTermineTerminNotiz.FieldName := 'TerminNotiz';
    xdsTermineTerminNotiz.Size := 255;
    xdsTermineQuelle.SetParentComponent(xdsTermine);
    xdsTermineQuelle.Name := 'xdsTermineQuelle';
    xdsTermineQuelle.FieldName := 'Quelle';
    xdsTermineQuelle.Size := 10;
    xdsTermineGUIDOutlook.SetParentComponent(xdsTermine);
    xdsTermineGUIDOutlook.Name := 'xdsTermineGUIDOutlook';
    xdsTermineGUIDOutlook.FieldName := 'GUIDOutlook';
    xdsTermineGUIDOutlook.Size := 250;
    xdsTermineShape.SetParentComponent(xdsTermine);
    xdsTermineShape.Name := 'xdsTermineShape';
    xdsTermineShape.FieldName := 'Shape';
    xdsTermineColor.SetParentComponent(xdsTermine);
    xdsTermineColor.Name := 'xdsTermineColor';
    xdsTermineColor.FieldName := 'Color';
    xdsTermineAlarm.SetParentComponent(xdsTermine);
    xdsTermineAlarm.Name := 'xdsTermineAlarm';
    xdsTermineAlarm.FieldName := 'Alarm';
    xdsTermineResource.SetParentComponent(xdsTermine);
    xdsTermineResource.Name := 'xdsTermineResource';
    xdsTermineResource.FieldName := 'Resource';
    xdsTermineLastModificationTime.SetParentComponent(xdsTermine);
    xdsTermineLastModificationTime.Name := 'xdsTermineLastModificationTime';
    xdsTermineLastModificationTime.FieldName := 'LastModificationTime';
    xdsTermineGeburtstag.SetParentComponent(xdsTermine);
    xdsTermineGeburtstag.Name := 'xdsTermineGeburtstag';
    xdsTermineGeburtstag.FieldName := 'Geburtstag';
    xdsTermineAlarmBefore.SetParentComponent(xdsTermine);
    xdsTermineAlarmBefore.Name := 'xdsTermineAlarmBefore';
    xdsTermineAlarmBefore.FieldName := 'AlarmBefore';
    xdsTerminePersonalnummer.SetParentComponent(xdsTermine);
    xdsTerminePersonalnummer.Name := 'xdsTerminePersonalnummer';
    xdsTerminePersonalnummer.FieldName := 'Personalnummer';
    xdsTermineKundennummer.SetParentComponent(xdsTermine);
    xdsTermineKundennummer.Name := 'xdsTermineKundennummer';
    xdsTermineKundennummer.FieldName := 'Kundennummer';
    xdsTermineKundennummer.Size := 13;
    xdsTermineAllDayEventOutlook.SetParentComponent(xdsTermine);
    xdsTermineAllDayEventOutlook.Name := 'xdsTermineAllDayEventOutlook';
    xdsTermineAllDayEventOutlook.FieldName := 'AllDayEventOutlook';
    xdsTermineTMSCaption.SetParentComponent(xdsTermine);
    xdsTermineTMSCaption.Name := 'xdsTermineTMSCaption';
    xdsTermineTMSCaption.FieldName := 'TMSCaption';
    xdsTermineRECURRENCY.SetParentComponent(xdsTermine);
    xdsTermineRECURRENCY.Name := 'xdsTermineRECURRENCY';
    xdsTermineRECURRENCY.FieldName := 'RECURRENCY';
    xdsTermineRECURRENCY.Size := 255;
    xdsTermineMINTIME.SetParentComponent(xdsTermine);
    xdsTermineMINTIME.Name := 'xdsTermineMINTIME';
    xdsTermineMINTIME.FieldName := 'MINTIME';
    xdsTermineMAXTIME.SetParentComponent(xdsTermine);
    xdsTermineMAXTIME.Name := 'xdsTermineMAXTIME';
    xdsTermineMAXTIME.FieldName := 'MAXTIME';
    xdsTermineNachname.SetParentComponent(xdsTermine);
    xdsTermineNachname.Name := 'xdsTermineNachname';
    xdsTermineNachname.FieldName := 'Nachname';
    xdsTermineNachname.Size := 40;
    xdsTermineObjektReferenz.SetParentComponent(xdsTermine);
    xdsTermineObjektReferenz.Name := 'xdsTermineObjektReferenz';
    xdsTermineObjektReferenz.FieldName := 'ObjektReferenz';
    xdsTermineObjektReferenz.Size := 13;
    xdsTermineObjektnummer.SetParentComponent(xdsTermine);
    xdsTermineObjektnummer.Name := 'xdsTermineObjektnummer';
    xdsTermineObjektnummer.FieldName := 'Objektnummer';
    xdsTermineObjektnummer.Size := 25;
    xdsTermineTerminArt.SetParentComponent(xdsTermine);
    xdsTermineTerminArt.Name := 'xdsTermineTerminArt';
    xdsTermineTerminArt.FieldName := 'TerminArt';
    xdsTermineBeginnDatum.SetParentComponent(xdsTermine);
    xdsTermineBeginnDatum.Name := 'xdsTermineBeginnDatum';
    xdsTermineBeginnDatum.FieldName := 'BeginnDatum';
    xdsTermineBeginnUhrzeit.SetParentComponent(xdsTermine);
    xdsTermineBeginnUhrzeit.Name := 'xdsTermineBeginnUhrzeit';
    xdsTermineBeginnUhrzeit.FieldName := 'BeginnUhrzeit';
    xdsTermineEndeDatum.SetParentComponent(xdsTermine);
    xdsTermineEndeDatum.Name := 'xdsTermineEndeDatum';
    xdsTermineEndeDatum.FieldName := 'EndeDatum';
    xdsTermineEndeUhrzeit.SetParentComponent(xdsTermine);
    xdsTermineEndeUhrzeit.Name := 'xdsTermineEndeUhrzeit';
    xdsTermineEndeUhrzeit.FieldName := 'EndeUhrzeit';
    xdsTermineKalenderAnzeige.SetParentComponent(xdsTermine);
    xdsTermineKalenderAnzeige.Name := 'xdsTermineKalenderAnzeige';
    xdsTermineKalenderAnzeige.FieldName := 'KalenderAnzeige';
    xdsTermineStundensatz.SetParentComponent(xdsTermine);
    xdsTermineStundensatz.Name := 'xdsTermineStundensatz';
    xdsTermineStundensatz.FieldName := 'Stundensatz';
    xdsTermineDauerStunden.SetParentComponent(xdsTermine);
    xdsTermineDauerStunden.Name := 'xdsTermineDauerStunden';
    xdsTermineDauerStunden.FieldName := 'DauerStunden';
    xdsTerminegefahrenekm.SetParentComponent(xdsTermine);
    xdsTerminegefahrenekm.Name := 'xdsTerminegefahrenekm';
    xdsTerminegefahrenekm.FieldName := 'gefahrenekm';
    xdsTermineAufwand.SetParentComponent(xdsTermine);
    xdsTermineAufwand.Name := 'xdsTermineAufwand';
    xdsTermineAufwand.FieldName := 'Aufwand';
    xdsTermineabgerechnet.SetParentComponent(xdsTermine);
    xdsTermineabgerechnet.Name := 'xdsTermineabgerechnet';
    xdsTermineabgerechnet.FieldName := 'abgerechnet';
    xdsTermineverteilt.SetParentComponent(xdsTermine);
    xdsTermineverteilt.Name := 'xdsTermineverteilt';
    xdsTermineverteilt.FieldName := 'verteilt';
    xdsTermineTerminErledigt.SetParentComponent(xdsTermine);
    xdsTermineTerminErledigt.Name := 'xdsTermineTerminErledigt';
    xdsTermineTerminErledigt.FieldName := 'TerminErledigt';
    xdsTermineAnsprechpartner.SetParentComponent(xdsTermine);
    xdsTermineAnsprechpartner.Name := 'xdsTermineAnsprechpartner';
    xdsTermineAnsprechpartner.FieldName := 'Ansprechpartner';
    xdsTermineAnsprechpartner.Size := 50;
    xdsTermineLocation.SetParentComponent(xdsTermine);
    xdsTermineLocation.Name := 'xdsTermineLocation';
    xdsTermineLocation.FieldName := 'Location';
    xdsTermineLocation.Size := 100;
    xdsTermineGoogleID.SetParentComponent(xdsTermine);
    xdsTermineGoogleID.Name := 'xdsTermineGoogleID';
    xdsTermineGoogleID.FieldName := 'GoogleID';
    xdsTermineGoogleID.Size := 250;
    xdsTermineGoogleCreatedUTC.SetParentComponent(xdsTermine);
    xdsTermineGoogleCreatedUTC.Name := 'xdsTermineGoogleCreatedUTC';
    xdsTermineGoogleCreatedUTC.FieldName := 'GoogleCreatedUTC';
    xdsTermineGoogleUpdatedUTC.SetParentComponent(xdsTermine);
    xdsTermineGoogleUpdatedUTC.Name := 'xdsTermineGoogleUpdatedUTC';
    xdsTermineGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsTermineGoogleStatus.SetParentComponent(xdsTermine);
    xdsTermineGoogleStatus.Name := 'xdsTermineGoogleStatus';
    xdsTermineGoogleStatus.FieldName := 'GoogleStatus';
    xdsTermineGoogleStatus.Size := 50;
    xdsTermineVorname.SetParentComponent(xdsTermine);
    xdsTermineVorname.Name := 'xdsTermineVorname';
    xdsTermineVorname.FieldName := 'Vorname';
    xdsTermineVorname.Size := 40;
    xdsTerminePNachname.SetParentComponent(xdsTermine);
    xdsTerminePNachname.Name := 'xdsTerminePNachname';
    xdsTerminePNachname.FieldName := 'PNachname';
    xdsTerminePNachname.Size := 40;
    xdsTerminePVorname.SetParentComponent(xdsTermine);
    xdsTerminePVorname.Name := 'xdsTerminePVorname';
    xdsTerminePVorname.FieldName := 'PVorname';
    xdsTerminePVorname.Size := 40;
    xdsTermineArtikelueberschrift.SetParentComponent(xdsTermine);
    xdsTermineArtikelueberschrift.Name := 'xdsTermineArtikelueberschrift';
    xdsTermineArtikelueberschrift.FieldName := 'Artikelueberschrift';
    xdsTermineArtikelueberschrift.Size := 50;
    xdsTerminePFarbe.SetParentComponent(xdsTermine);
    xdsTerminePFarbe.Name := 'xdsTerminePFarbe';
    xdsTerminePFarbe.FieldName := 'PFarbe';
    xdsTermineKontaktart.SetParentComponent(xdsTermine);
    xdsTermineKontaktart.Name := 'xdsTermineKontaktart';
    xdsTermineKontaktart.FieldName := 'Kontaktart';
    xdsTermineKontaktart.Size := 25;
    xdsTermineAuftrag.SetParentComponent(xdsTermine);
    xdsTermineAuftrag.Name := 'xdsTermineAuftrag';
    xdsTermineAuftrag.FieldName := 'Auftrag';
    xdsTermineAuftrag.Size := 10;
    xdsTermineRechnung.SetParentComponent(xdsTermine);
    xdsTermineRechnung.Name := 'xdsTermineRechnung';
    xdsTermineRechnung.FieldName := 'Rechnung';
    xdsTermineRechnung.Size := 10;
    xdsTermineRechnungPosID.SetParentComponent(xdsTermine);
    xdsTermineRechnungPosID.Name := 'xdsTermineRechnungPosID';
    xdsTermineRechnungPosID.FieldName := 'RechnungPosID';
    xdsTermineRechnungPosID.Size := 10;
    xdsTermineAbrechnen.SetParentComponent(xdsTermine);
    xdsTermineAbrechnen.Name := 'xdsTermineAbrechnen';
    xdsTermineAbrechnen.FieldName := 'Abrechnen';
  finally
    btnzurueck.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnTerminNeu.AfterLoadDFMValues;
    xdsTermine.AfterLoadDFMValues;
    xdsTermineArtikelnummer.AfterLoadDFMValues;
    xdsTermineUID.AfterLoadDFMValues;
    xdsTermineBeginn.AfterLoadDFMValues;
    xdsTermineEnde.AfterLoadDFMValues;
    xdsTermineBetreff.AfterLoadDFMValues;
    xdsTermineTerminNotiz.AfterLoadDFMValues;
    xdsTermineQuelle.AfterLoadDFMValues;
    xdsTermineGUIDOutlook.AfterLoadDFMValues;
    xdsTermineShape.AfterLoadDFMValues;
    xdsTermineColor.AfterLoadDFMValues;
    xdsTermineAlarm.AfterLoadDFMValues;
    xdsTermineResource.AfterLoadDFMValues;
    xdsTermineLastModificationTime.AfterLoadDFMValues;
    xdsTermineGeburtstag.AfterLoadDFMValues;
    xdsTermineAlarmBefore.AfterLoadDFMValues;
    xdsTerminePersonalnummer.AfterLoadDFMValues;
    xdsTermineKundennummer.AfterLoadDFMValues;
    xdsTermineAllDayEventOutlook.AfterLoadDFMValues;
    xdsTermineTMSCaption.AfterLoadDFMValues;
    xdsTermineRECURRENCY.AfterLoadDFMValues;
    xdsTermineMINTIME.AfterLoadDFMValues;
    xdsTermineMAXTIME.AfterLoadDFMValues;
    xdsTermineNachname.AfterLoadDFMValues;
    xdsTermineObjektReferenz.AfterLoadDFMValues;
    xdsTermineObjektnummer.AfterLoadDFMValues;
    xdsTermineTerminArt.AfterLoadDFMValues;
    xdsTermineBeginnDatum.AfterLoadDFMValues;
    xdsTermineBeginnUhrzeit.AfterLoadDFMValues;
    xdsTermineEndeDatum.AfterLoadDFMValues;
    xdsTermineEndeUhrzeit.AfterLoadDFMValues;
    xdsTermineKalenderAnzeige.AfterLoadDFMValues;
    xdsTermineStundensatz.AfterLoadDFMValues;
    xdsTermineDauerStunden.AfterLoadDFMValues;
    xdsTerminegefahrenekm.AfterLoadDFMValues;
    xdsTermineAufwand.AfterLoadDFMValues;
    xdsTermineabgerechnet.AfterLoadDFMValues;
    xdsTermineverteilt.AfterLoadDFMValues;
    xdsTermineTerminErledigt.AfterLoadDFMValues;
    xdsTermineAnsprechpartner.AfterLoadDFMValues;
    xdsTermineLocation.AfterLoadDFMValues;
    xdsTermineGoogleID.AfterLoadDFMValues;
    xdsTermineGoogleCreatedUTC.AfterLoadDFMValues;
    xdsTermineGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsTermineGoogleStatus.AfterLoadDFMValues;
    xdsTermineVorname.AfterLoadDFMValues;
    xdsTerminePNachname.AfterLoadDFMValues;
    xdsTerminePVorname.AfterLoadDFMValues;
    xdsTermineArtikelueberschrift.AfterLoadDFMValues;
    xdsTerminePFarbe.AfterLoadDFMValues;
    xdsTermineKontaktart.AfterLoadDFMValues;
    xdsTermineAuftrag.AfterLoadDFMValues;
    xdsTermineRechnung.AfterLoadDFMValues;
    xdsTermineRechnungPosID.AfterLoadDFMValues;
    xdsTermineAbrechnen.AfterLoadDFMValues;
  end;
end;

end.